import {AfterViewInit, Component, OnInit } from '@angular/core';
import {} from 'googlemaps';
import { ViewChild } from '@angular/core';
@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})


export class ContactoComponent implements OnInit {
 
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
   
 }
}
